module.exports = "/images/vendor/flag-icon-css/flags/1x1/pn.svg?48bd62e408e5f6ebafd146d2231c2e4b";